import Pending from '../components/SignatureUser/Pending'

let routes = {
    path: '/myPending/',
    component: resolve => require(['../components/layout/Basic/App'], resolve),
    children: [
        {
            path: '/myPending',
            name: 'Documentos Pendentes',
            component: Pending
        },
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/pending.js